<template>
    <div class="addteamUser">
        <div class="add_container">
            <div class="fai_notext_field  flex align-cen">
                <div class="fai_notext_field_label">成员姓名</div>
                  <div style="margin-left:50px;">
                   <el-input placeholder="请输入姓名" v-model="userName" clearable></el-input>
                  </div>
            </div>
            <div class="fai_notext_field  flex align-cen">
                <div class="fai_notext_field_label">电话号码</div>
                  <div style="margin-left:50px;">
                   <el-input placeholder="请输入姓名" v-model="loginName" clearable disabled></el-input>
                  </div>
            </div>
            <div class="fai_notext_field  flex align-cen">
                <div class="fai_notext_field_label">成员权限</div>
                <el-radio-group v-model="radio" style="margin-left:50px">
                <el-radio :label="2">管理员</el-radio>
                <el-radio :label="0">使用者</el-radio>
            </el-radio-group>
            </div>
            <div class="fai_notext_field flex align-cen" v-if="radio==2">
            <div class="fai_notext_field_label">管理权限</div>
            <div style="color:rgb(255,74,59);margin-left:50px;font-size:12px">能够编辑管理团队人员，使用所有购买的应用</div>
            </div>
         <div class="fai_notext_field  flex">
             <div class="fai_notext_field_label" style="line-height:40px">授权应用</div>
             <div class="addform ">
                <div class="addform-list flex align-cen" v-for="(item,index) in authAppVOList">
                    <div class="appname">{{item.appName}}</div>
                    <div class="apptime" v-if="item.timeLimit == 1">【无时间限制】</div>
                     <div class="apptime" v-else>【{{item.startTime}} ~ {{item.endTime}}】</div>
                </div>
                <!-- <el-tree
            ref="tree"
            :data="itemList"
            show-checkbox
            node-key="id"
            :default-expand-all="expandall"
            :default-checked-keys="checkTrue"
            :props="defaultProps"
            @check="checkHandler"
            v-loading = "loading"
            >
            </el-tree> -->
             </div>
         </div>
         <div class="btm_btn_box flex align-cen">
            <div class="fai_submit_btn" @click="copyLink">确定</div>
            <div class="fai_cancel_btn1" @click="deletFun">删除成员</div>
            <div class="fai_cancel_btn" @click="reback">取消</div>
         </div>
        </div>
    </div>
</template>
<script>
import { getappAuth,editAccount,deletAccount,getTeamDetail} from "@/api/enterprise/index"; // 权限树列表、设置成员、删除成员、成员详情
export default {
    name:'addteamUser',
    data () {
        return {
            authAppVOList:[],
            loginName:'',
            userName:'',
            loading:false,
            nowDate:'',
            endDate:'',
            expandall:true,
            radio:0,
            bussID:'',
            currentId:'',
            itemList:[],
            checkTrue:[],
            currentUserInfo:'',
            businessInfo:'',
            defaultProps: {
          children: 'appAuthAccountVOList',
          label: 'name',
        },
        authList:[],
          propList:[]
        }
    },
    created () {
         let decryptQuery=this.$base64.decode(this.$route.query.parms); // 解密
         this.propList = JSON.parse(decryptQuery)
         this.userName = this.propList.userName
         this.loginName = this.propList.loginName
        //  this.radio = Number(this.propList.isAdmin)
     const businessInfo = this.$locaStorage.setAge().get('businessInfo')
     this.businessInfo = businessInfo
     this.bussID = businessInfo.id
     this.gethisInfo()
    },
    methods: {
        // 获取详情
        gethisInfo(){
             getTeamDetail({businessId:this.bussID,id: this.propList.id},'enterprise')
            .then(res =>{
        this.userName = res.data.userName
         this.loginName = res.data.loginName
         this.radio = Number(res.data.isAdmin)
         this.authAppVOList = res.data.authAppVOList
            })
        },
        // 删除成员
        deletFun(){
             this.$confirm('删除该成员后，该成员账号无法登录本团队，确认删除吗？','删除成员', {
          confirmButtonText: '仍然删除',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
            deletAccount({
                accountId:this.propList.id,
                businessId:this.bussID,
              },'enterprise')
                .then(res => {
                 this.$util.Notifi('删除成功','success','fa-check')
                 this.$router.replace('/webenterpriseManage/teamAdmin')
              })
              .catch(err => {
              })
        })
        },
        // 设置成员
        copyLink(){
           let params = {
            userName:this.userName,
            accountId:this.propList.id,
            businessId:this.bussID,
            isAdmin:this.radio,
           }
          editAccount(params,'enterprise')
          .then(res =>{
            if(res.code == 0){
                this.$util.Notifi('设置成功','success','fa-check')
                this.reback()
            }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
            }
          })
          .catch(err =>{this.$util.Notifi(err.msg,'error','fa-exclamation-circle')})
        },
        // 返回上一页
        reback(){
            this.$router.push('/webenterpriseManage/teamAdmin')
        },
        // 获取应用树列表
        gethisList(){
            this.loading = true
             getappAuth({id:this.bussID,accountId:this.propList.id},'enterprise')
            .then(res =>{
               this.loading = false
               this.itemList = this.getAllName(res.data)
                this.checkTrue = this.getAllNodeId(this.checkTrue,res.data) 
                this.authList = this.checkTrue
            })
            .catch(err =>{this.loading = false})
        },
        // 递归修改子集name
         getAllName (moduleDataList) {
            let list = moduleDataList.map((item)=>{
                    if(item.appAuthAccountVOList){
                        this.getAllName(item.appAuthAccountVOList)
                    }
                    item.isApp == 1 ? item.name = item.name + '【可分配' + item.accountNum + '个账号】' : item.name = item.name
                    item.accountNum && item.accountNum <= 0 ? item['disabled'] = true : item['disabled'] = false
                    return item
                })
                return list
         },
        // 递归查询选中
         getAllNodeId (expandedKeys,moduleDataList) {
            this.checkTrue = []
            for (let i = 0; i < moduleDataList.length; i++) {
                if(moduleDataList[i].isAuth == 1 && moduleDataList[i].isApp == 1){
                    expandedKeys.push(moduleDataList[i].id)
                }
                if (moduleDataList[i].appAuthAccountVOList) {
                     expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].appAuthAccountVOList)
                }
            }
             return expandedKeys
         },
        checkHandler(...value){
            this.authList = []
            let checkedKeys = this.$refs.tree.getCheckedNodes()
             for (let i in checkedKeys) {
                if(checkedKeys[i].isApp == 1){
                this.authList.push(checkedKeys[i].id)
                }
            }
            // truu勾选的方法
        },
    },
}
</script>
<style lang="scss" scoped>
.addteamUser{
    padding-top: 30px;
    font-weight: 400;
    .add_container{
     position: relative;
    margin: 0 auto;
    width: 1000px;
    background-color: #fff;
    box-shadow: 0 0 7px 0 rgba(197,197,197,0.34);
    padding: 40px 105px;
    box-sizing: border-box;
    margin-bottom: 40px;
    .fai_notext_field {
    min-height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
    .fai_notext_field_label{
    font-size: 12px;
    color: #90909e;
    text-align: right;
    }
    }
    .btm_btn_box{
        margin-top: 30px;    
        justify-content: center;
    .fai_submit_btn,.fai_cancel_btn,.fai_cancel_btn1{
        width: 270px;
            height: 40px;
    line-height: 40px;
    background: rgba(255,255,255,1);
    border-radius: 2px;
    box-sizing: content-box;
    font-size: 16px;
    cursor: pointer;
    transition: all .3s linear;
    text-align: center;
    }
    .fai_submit_btn{
        border: 1px solid rgba(1,87,255,1);
        color: #0157ff;
    }
    .fai_cancel_btn{
    border: 1px solid rgba(1,87,255,1);
    color: #0157ff;
    border: 1px solid #dadada;
    color: #90909e;
    margin-left: 30px;
    }
       .fai_cancel_btn1{
        border: 1px solid red;
    color: red;
    margin-left: 30px;
       }
    }
    }
}
::v-deep {
  .addform{
    margin-left: 50px;
    flex-wrap: wrap;
    .addform-list{
        // width: 100%;
        .appname{
            line-height:35px;
        }
        .apptime{
            color: red;
        }
    }
      .el-tree-node__content{
          height: 40px !important;
      }
      .el-tree{
          display: flex;
          flex-wrap: wrap;
      }
  }
}
</style>